import axiosClient from './axiosClient'
import queryString from 'query-string'

const newsApi = {
    getNews: params => {
        const paramsString = queryString.stringify(params);
        return axiosClient.get(`/news?${paramsString}`)
    },
    getSingleNews: params => {
        return axiosClient.get(`/news/${params}`)
    },
    deleteNews: params => {
        return axiosClient.delete(`/news/${params}`)
    },
    postNews: params => {
        return axiosClient.post('/news', params)
    },
    updateNews: params => {
        
        return axiosClient.put(`/news/${params.id}`, params.formData)
    },
    getNewsNew: params => {
        const paramsString = queryString.stringify(params);
        return axiosClient.get(`/news/news-new?${paramsString}`)
    },
    getNewsFromCategory: params => {
        const paramsString = queryString.stringify(params);
        return axiosClient.get(`/news/category/?${paramsString}`)
    },
    getHighlightNews: params => {
        const paramsString = queryString.stringify(params)
        return axiosClient.get(`/news/highlight?${paramsString}`)
    },
    getMostViewNews: params => {
        const paramsString = queryString.stringify(params)
        return axiosClient.get(`/news/mostview?${paramsString}`)
    },
    getNewsFocus: () => {
        return axiosClient.get('/news/focus')
    },
    search: params => {
        const paramsString = queryString.stringify(params)
        return axiosClient.get(`/news/search?${paramsString}`)
    }
}

export default newsApi